// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ss { position: relative; display: inline-block; width: 100%; }

.ss-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 3px 6px;
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 2px;
  color: var(--text-primary);
  font-size: 12px;
  cursor: pointer;
  gap: 4px;
  text-align: left;
}
.ss-trigger:hover { border-color: var(--text-muted); }
.ss-open .ss-trigger { border-color: var(--accent-light); }
.ss-dis .ss-trigger { opacity: 0.5; cursor: not-allowed; }

.ss-ph { color: var(--text-muted); flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ss-val { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ss-arr { flex-shrink: 0; color: var(--text-muted); }

.ss-drop {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 3px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.5);
  overflow: hidden;
}

.ss-search-wrap {
  padding: 5px 6px;
  border-bottom: 1px solid var(--border);
}
.ss-search-wrap input {
  width: 100%;
  font-size: 12px;
  padding: 3px 6px;
}

.ss-opts { max-height: 220px; overflow-y: auto; position: relative; }

.ss-opt {
  padding: 5px 10px;
  font-size: 12px;
  cursor: pointer;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ss-opt.ss-hi { background: var(--bg-hover); }
.ss-opt.ss-sel { color: var(--accent-light); }
.ss-none { color: var(--text-muted); }
.ss-empty { padding: 8px 10px; font-size: 12px; color: var(--text-muted); }
`, "",{"version":3,"sources":["webpack://./src/components/common/SearchSelect.css"],"names":[],"mappings":"AAAA,MAAM,kBAAkB,EAAE,qBAAqB,EAAE,WAAW,EAAE;;AAE9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;AACA,oBAAoB,+BAA+B,EAAE;AACrD,uBAAuB,iCAAiC,EAAE;AAC1D,sBAAsB,YAAY,EAAE,mBAAmB,EAAE;;AAEzD,SAAS,wBAAwB,EAAE,OAAO,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5G,UAAU,OAAO,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACnF,UAAU,cAAc,EAAE,wBAAwB,EAAE;;AAEpD;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAEpE;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,gBAAgB,2BAA2B,EAAE;AAC7C,iBAAiB,0BAA0B,EAAE;AAC7C,WAAW,wBAAwB,EAAE;AACrC,YAAY,iBAAiB,EAAE,eAAe,EAAE,wBAAwB,EAAE","sourcesContent":[".ss { position: relative; display: inline-block; width: 100%; }\n\n.ss-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 3px 6px;\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  color: var(--text-primary);\n  font-size: 12px;\n  cursor: pointer;\n  gap: 4px;\n  text-align: left;\n}\n.ss-trigger:hover { border-color: var(--text-muted); }\n.ss-open .ss-trigger { border-color: var(--accent-light); }\n.ss-dis .ss-trigger { opacity: 0.5; cursor: not-allowed; }\n\n.ss-ph { color: var(--text-muted); flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.ss-val { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.ss-arr { flex-shrink: 0; color: var(--text-muted); }\n\n.ss-drop {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  box-shadow: 0 6px 20px rgba(0,0,0,0.5);\n  overflow: hidden;\n}\n\n.ss-search-wrap {\n  padding: 5px 6px;\n  border-bottom: 1px solid var(--border);\n}\n.ss-search-wrap input {\n  width: 100%;\n  font-size: 12px;\n  padding: 3px 6px;\n}\n\n.ss-opts { max-height: 220px; overflow-y: auto; position: relative; }\n\n.ss-opt {\n  padding: 5px 10px;\n  font-size: 12px;\n  cursor: pointer;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ss-opt.ss-hi { background: var(--bg-hover); }\n.ss-opt.ss-sel { color: var(--accent-light); }\n.ss-none { color: var(--text-muted); }\n.ss-empty { padding: 8px 10px; font-size: 12px; color: var(--text-muted); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
